import type { CoverageStatus } from '@/modules/projects/components/StatementCoverage/types'
import { HiddenAccounts } from '@/modules/projects/components/Workbench/HiddenAccounts'
import type { HiddenLanes } from '@/modules/projects/components/Workbench/map'
import type {
  Highlight,
  MapFilters,
} from '@/modules/projects/components/Workbench/mapView'
import { PendingNote } from '@/modules/projects/components/Workbench/PendingNote'
import { YearPicker } from '@/modules/projects/components/Workbench/YearPicker'
import { HighlightChips } from './HighlightChips'

export interface MapToolbarProps {
  years: number[]
  filters: MapFilters
  counts: Record<CoverageStatus, number>
  coverageArriving: boolean
  highlight: Highlight
  hidden: HiddenLanes
  onFilters: (next: MapFilters) => void
  onHighlight: (next: Highlight) => void
  onShowAllAccounts: () => void
}

// The map's filters, gathered at the right end of the bar beside its actions: what to pick out,
// then which years to show.
export const MapToolbar = ({
  years,
  filters,
  counts,
  coverageArriving,
  highlight,
  hidden,
  onFilters,
  onHighlight,
  onShowAllAccounts,
}: MapToolbarProps) => (
  <div className="flex min-w-0 flex-1 items-center justify-end gap-4">
    {hidden.accounts + hidden.memberCards > 0 ? (
      <HiddenAccounts hidden={hidden} onShowAll={onShowAllAccounts} />
    ) : null}

    <div className="min-w-0 overflow-x-auto scrollbar-hide">
      {coverageArriving ? (
        <PendingNote text="Checking coverage…" />
      ) : (
        <HighlightChips
          counts={counts}
          highlight={highlight}
          onHighlight={onHighlight}
        />
      )}
    </div>

    {years.length > 1 ? (
      <YearPicker years={years} filters={filters} onFilters={onFilters} />
    ) : null}
  </div>
)
